/**
 * Herkese açık yol haritası. Kaynak: Linear proje ve kilometre taşları.
 * Bitmemiş olan bitmemiş denir (docs/marka.md); tarih vermiyoruz, sıra veriyoruz.
 */
export interface Faz {
  ad: string
  baslik: string
  durum: 'tamam' | 'suruyor' | 'sirada'
  maddeler: string[]
}

export const FAZLAR: Faz[] = [
  {
    ad: 'Faz 0',
    baslik: 'Platform temeli',
    durum: 'tamam',
    maddeler: [
      'Çok kiracılı yapı ve veritabanı seviyesinde izolasyon',
      'Kimlik, roller, izinler, ikinci adım doğrulama',
      'Plan ve özellik bayrakları',
      'Şifreli sağlayıcı anahtarları',
      'Denetim kaydı',
      'Otomatik dağıtım ve sürüm doğrulama',
    ],
  },
  {
    ad: 'Faz 1',
    baslik: 'Üyelik, aidat, site',
    durum: 'suruyor',
    maddeler: [
      'Üye yönetimi, başvuru akışı, özel alanlar, Excel içe aktarım',
      'Aidat tarifeleri, borçlandırma, online tahsilat, makbuz',
      'Kurullar, toplantı ve karar defteri',
      'Üye portalı: başvuru, borç, ödeme, destek',
      'Web sitesi şablonları ve özel alan adı',
      'E-posta kampanyaları; SMS kendi Netgsm hesabınızdan',
      'İki katmanlı destek',
    ],
  },
  {
    ad: 'Faz 2',
    baslik: 'Kongre, mobil, mali',
    durum: 'sirada',
    maddeler: [
      'Etkinlik motoru: bilet, konaklama, transfer, QR kapı, sponsor, sertifika',
      'Mobil uygulama: dijital üye kartı, aidat, etkinlik, yönetici modu',
      'Gelir-gider, kasa/banka, bütçe, banka hareketi eşleştirme',
      'Bağış sayfası, kampanya, burs ve gönüllü takibi',
      'Beyanname hazırlığı dökümleri',
      'Param ve Paraşüt bağlantıları',
    ],
  },
  {
    ad: 'Faz 3',
    baslik: 'Akademi ve genel kurul',
    durum: 'sirada',
    maddeler: [
      'Kurs, video ders, sınav, sertifika',
      'Yerleşik webinar ve Zoom ile çalışma',
      'Online genel kurul: canlı oturum, kayıt, hazirun, elektronik oylama',
      'WhatsApp bildirimi',
    ],
  },
  {
    ad: 'Faz 4',
    baslik: 'Mağaza ve depo',
    durum: 'sirada',
    maddeler: ['Katalog, varyant, fiyat listeleri', 'Stok, depo, sayım', 'Kargo, kampanya, iade'],
  },
]
